
























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Partner from '@/components/public/Partner.vue'
import orderApi from '@/api/orderApi'
import moment from 'moment'
import ShowImg from '@/components/ui/ShowImg.vue'
import CountDown from '@/components/ui/CountDown.vue'
import listApi from '@/api/listApi'
import router from '@/router'
/**
 * 订单详情
 */
@Component({
  components: {
    ShowImg,
    CountDown,
    Partner
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY-MM-DD  HH:mm')
    },
    format(value: any) {
      return moment(Number(value)).format('YYYY-MM-DD')
    }
  }
})
export default class OrderDetails extends Vue {
  @Prop()
  public orderCode: string
  private orderStatus: number = 4
  private details: any = {}
  private goodsList: any = []
  public mounted() {
    this.getOrderDetails()
    this.getResourcesListLeft()
  }

  protected getOrderDetails() {
    orderApi.getOrderDetails({
      orderCode: this.$route.query.orderCode
    }).then((res) => {
      if (res.code === 200) {
        this.details = res.data
      }
    })
  }

  protected goBuy() {
    this.$router.push({ name: 'pay', query: { orderNo: this.$route.query.orderCode } })
  }

  protected cancelOrder() {
    orderApi.cancelOrder({
      orderCode: this.$route.query.orderCode
    }).then((res) => {
      console.log(res)
      if (res.code === 200 && res.data) {
        this.$message.success('取消订单成功');
        this.$router.go(-1)
      }
    })
  }

  public  goImplement(item: any) {
    router.push({ name: 'order-implement', query: { orderCode: item } })
  }
  
  // 获取广告位
  private getResourcesListLeft() {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'ORDER_DETAILS',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.goodsList = res.data
      }
    })
  }
}
